module.exports = __webpack_public_path__ + "static/media/border-bottom.1a93151d.svg";